module.exports = __webpack_public_path__ + "static/media/Lec2.e23d772a.png";